import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { PortalModule } from '@angular/cdk/portal';

import { MatIconModule } from '@angular/material/icon';

import { MatMomentDateModule } from '@angular/material-moment-adapter';

import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSortModule } from '@angular/material/sort';
import { MatTabsModule } from '@angular/material/tabs';
// import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { NgPipesModule } from 'ngx-pipes';

/**
 * Shared states used by saas modules.
 */
/**
 * Shared modules used by saas modules.
 */
import { BasicModule } from '@shared/modules/basic.module';
import { HelpCenterModule } from '@shared/modules/help-center/help-center.module';
import { LindaModule } from '@shared/modules/linda.module';
import { LocalesModule } from '@shared/modules/locales.module';
import { TrackingModule } from '@shared/modules/tracking.module';
import { YoutubePlayerModule } from '@shared/modules/youtube-player/youtube-player.module';

@NgModule({
  exports: [
    BasicModule,
    LindaModule,
    LocalesModule,
    TrackingModule,
    HelpCenterModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    DragDropModule,
    MatMomentDateModule,
    MatIconModule,
    MatListModule,
    MatGridListModule,
    MatMenuModule,
    MatTabsModule,
    MatChipsModule,
    MatRadioModule,
    MatInputModule,
    MatButtonModule,
    MatSliderModule,
    MatDialogModule,
    MatDividerModule,
    MatToolbarModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatSortModule,
    NgPipesModule,
  ],
  imports: [
    BasicModule,
    LindaModule,
    LocalesModule,
    TrackingModule,
    HelpCenterModule,
    FormsModule,
    CommonModule,
    RouterModule,
    PortalModule,
    DragDropModule,
    MatMomentDateModule,
    MatIconModule,
    MatListModule,
    MatGridListModule,
    MatMenuModule,
    MatTabsModule,
    MatChipsModule,
    MatRadioModule,
    MatInputModule,
    MatButtonModule,
    MatSliderModule,
    MatDialogModule,
    MatToolbarModule,
    MatDividerModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSnackBarModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    MatSortModule,
    NgPipesModule,
    YoutubePlayerModule,
  ],
})
export class SharedModule {}
